import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useConsent } from "../ui/CookieConsent.jsx";

/* ============================================================
   Google Analytics 4 — SPA pageview tracking
   ============================================================
   Replace GA_ID below with your real Measurement ID from 
   analytics.google.com → Admin → Data Streams.
   
   Only fires when the user has accepted cookies (LGPD).
   The gtag.js script is loaded by index.html, but if the 
   user rejects cookies, this hook does nothing.
   
   Set the same GA_ID in index.html's gtag config block.
   ============================================================ */

const GA_ID = "G-XXXXXXXXXX"; // TODO: replace after creating GA4 property

export function useAnalytics() {
  const { pathname, search } = useLocation();
  const { hasConsented } = useConsent();

  useEffect(() => {
    if (GA_ID === "G-XXXXXXXXXX") return;
    if (!hasConsented) return;
    if (typeof window.gtag !== "function") return;
    window.gtag("config", GA_ID, {
      page_path: pathname + search,
      page_title: document.title,
    });
  }, [pathname, search, hasConsented]);
}
